import { Button, Col, Divider, Form, InputNumber, Radio, Row, Typography, notification } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import Title from 'antd/lib/typography/Title';
import packAPI from '~/api/PackAPI';
import { getPriceWithCommas } from '~/utils';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getInfoProfile } from '~/store/actions/UserAction';
import styles from './SplitCard.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);
const radioList = [
    {
        value: 5000000,
    },
    {
        value: 10000000,
    },
    {
        value: 20000000,
    },
    {
        value: 50000000,
    },
    {
        value: 100000000,
    },
    {
        value: 200000000,
    },
];
function SplitCard({ wallet, userId, setIsShowSplitCard, handleGetMyCard }) {
    const dispatch = useDispatch();
    const [valueMinus, setValueMinus] = useState(0);

    const results = useMemo(() => {
        return wallet - valueMinus;
    }, [valueMinus]);

    const [selectValue, setSelectValue] = useState(radioList[0].value);

    const [loading, setLoading] = useState(false);
    const handleChange = (e) => {
        setSelectValue(e.target.value);
    };
    const [form] = useForm();
    const count = Form.useWatch('count', form);
    const userEndow = 100;

    const [errors, setErrors] = useState({
        outMoney: '',
    });
    useEffect(() => {
        const totalMinus = selectValue * (count || 1) * (userEndow / 100);
        setValueMinus(totalMinus);
        if (totalMinus > wallet) {
            setErrors((prev) => ({
                ...prev,
                outMoney: 'Service limit amount is not enough',
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                outMoney: '',
            }));
        }
        form.setFieldValue('selectValue', selectValue);
    }, [selectValue, count, userEndow]);

    const handleFinish = async (data) => {
        const body = {
            ...data,
            value: selectValue,
            endow: 100,
            owner_id: userId,
        };
        setLoading(true);
        try {
            const res = await packAPI.addNewCardAPI(body);
            notification.open({
                message: 'Created card successfully',
                duration: 2,
                placement: 'top',
            });
            dispatch(getInfoProfile());
            setLoading(false);
            setIsShowSplitCard(false);
            setTimeout(() => {
                handleGetMyCard(1);
            }, 1000);
        } catch (err) {
            notification.open({
                message: err?.message,
                duration: 2,
                placement: 'top',
            });
            setLoading(false);
        }
    };

    const onChange = (value) => {
        setSelectValue(value);
    };

    return (
        <>
            <Row
                gutter={[16, 16]}
                style={{
                    paddingTop: '20px',
                }}
            >
                <Col span={12} className={cx('titlePC')}>
                    <Title level={5}>Current amount: </Title>
                </Col>
                <Col span={14} className={cx('titleMB')}>
                    <Title level={5}>Service limit: </Title>
                </Col>
                <Col span={12} className={cx('titlePC')}>
                    <Typography
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        {getPriceWithCommas(wallet)}
                    </Typography>
                </Col>
                <Col span={10} className={cx('titleMB')}>
                    <Typography
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        {getPriceWithCommas(wallet)}
                    </Typography>
                </Col>
                <Col span={12} className={cx('titlePC')}>
                    <Title level={5}>Amount deducted: </Title>
                </Col>
                <Col span={12} className={cx('titlePC')}>
                    <Typography
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        - {getPriceWithCommas(valueMinus)}
                    </Typography>
                </Col>

                <Divider style={{ color: 'black', margin: 0, background: 'black' }} />

                <Col span={12} className={cx('titlePC')}>
                    <Title level={5}>Remaining amount: </Title>
                </Col>
                <Col span={12} className={cx('titleMB')}>
                    <Title level={5}>Remaining balance:</Title>
                </Col>
                <Col span={12}>
                    <Typography
                        style={{
                            textAlign: 'right',
                            color: results < 0 ? 'red' : 'black',
                        }}
                    >
                        {getPriceWithCommas(results)}
                    </Typography>
                </Col>

                <Col span={24}>
                    <Typography
                        style={{
                            textAlign: 'left',
                            color: 'red',
                        }}
                    >
                        {errors.outMoney}
                    </Typography>
                </Col>
            </Row>

            <Title level={5}>Card value: </Title>

            <Radio.Group
                value={selectValue}
                style={{
                    marginTop: 16,
                }}
                onChange={handleChange}
            >
                <Row
                    gutter={[16, 16]}
                    style={{
                        padding: '20px',
                    }}
                >
                    {radioList.map((item) => (
                        <Col xs={24} sm={8}>
                            <Radio.Button
                                style={{ width: '100%', textAlign: 'center' }}
                                value={item.value}
                                className={cx('radio-custom')}
                            >
                                {getPriceWithCommas(item.value)}
                            </Radio.Button>
                        </Col>
                    ))}
                </Row>
            </Radio.Group>
            <Form
                style={{
                    padding: 20,
                }}
                form={form}
                layout="horizontal"
                autoComplete={false}
                onFinish={handleFinish}
                initialValues={{
                    count: 1,
                }}
            >
                <Row>
                    {/* <Col span={24}>
                        <Form.Item
                            name="selectValue"
                            label="Tag value: "
                            rules={[
                                { required: true, message: 'This field cannot be left blank' },
                                {
                                    type: 'number',
                                    min: 10000000,
                                    message: 'The lowest amount is 10,000,000 VND',
                                },
                            ]}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={(value) => value?.replace(/\$\s?|(,*)/g, '')}
                                onChange={onChange}
                            />
                        </Form.Item>
                    </Col> */}
                    <Col span={24}>
                        <Form.Item
                            name="count"
                            label="Quantity: "
                            rules={[
                                { required: true, message: 'This field cannot be left blank' },
                                {
                                    type: 'number',
                                    min: 1,
                                    message: 'The lowest quantity is 1',
                                },
                            ]}
                        >
                            <InputNumber style={{ width: '100%' }} min={1} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    wrapperCol={{ span: 24 }}
                    style={{
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        style={{
                            fontStyle: 'italic',
                            color: 'goldenrod',
                            textAlign: 'left',
                        }}
                    >
                        Note: <span style={{ fontWeight: 700 }}>{count} tag </span>
                        with the value <span style={{ fontWeight: 700 }}>{getPriceWithCommas(selectValue)}</span> will be
                        create
                    </Typography>
                </Form.Item>
                <Form.Item
                    wrapperCol={{ span: 24 }}
                    style={{
                        textAlign: 'center',
                    }}
                >
                    <Button
                        loading={loading}
                        type="primary"
                        htmlType="submit"
                        size="large"
                        className={cx('btn_submit')}
                        block
                        disabled={errors.outMoney}
                    >
                        Create tags
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default SplitCard;
